import * as Styled from '../../styles';

const Default = ({ base64Pdf }: { base64Pdf: string }): JSX.Element => {
  return <Styled.Iframe src={base64Pdf} type="application/pdf" />;
};

export default Default;
